runOnLoad "Autoresponders", ["show"], ->

  $('#unpause-autoresponder').click (event) ->
    link = $(@)
    body = link.data('body')

    if body
      event.preventDefault()

      modal =
        body: body
        dangerLabel: t('buttons.clear_queue')
        primaryLabel: t('buttons.process_reactions')

      Dialogs.presentModal modal, (action) ->
        location.href = link.attr('href') + ("&clear=1" if action == 'danger')


runOnLoad "Autoresponders", ["new", "create", "edit", "update"], ->

  SegmentationBuilder.setup()

  toggleDelayUnit = (value) ->
    if value && value != 'minutes' && value != 'hours'
      $('span.delay-time').show()
    else
      $('span.delay-time').hide()

  toggleDelayUnit $('#autoresponder_delay_unit').val()

  $(document).on 'change', '#autoresponder_trigger,#autoresponder_trigger_campaign_to_click_id,#autoresponder_trigger_autoresponder_to_click_id', ->

    list = $('#autoresponder_mailing_list_id').val()
    url  = Routes.render_trigger_settings_mailing_list_autoresponders_path(mailing_list_id: list)
    data = $(this).closest('form').find(".trigger_settings").find(":input").serialize()

    $.get url, data, (html) =>
      UI.setupSelects $(this).closest('ul').html(html)
      YesNoFieldToggler.setup()

  $(document).on 'change', '#autoresponder_delay', ->

    list = $('#autoresponder_mailing_list_id').val()
    url  = Routes.render_delay_settings_mailing_list_autoresponders_path(mailing_list_id: list)
    data = $(this).closest('form').find(".delay_settings").find(":input").serialize()

    $.get url, data, (html) =>
      UI.setupSelects $(this).closest('ul').html(html)
      toggleDelayUnit $('#autoresponder_delay_unit').val()

  $(document).on 'change', '#autoresponder_delay_unit', ->
    toggleDelayUnit $(@).val()

  $(document).on 'click', "a[href='#custom-delivery-setting']", ->
    $('#autoresponder_use_external_delivery_setting').val false

  $(document).on 'click', "a[href='#stored-delivery-setting']", ->
    $('#autoresponder_use_external_delivery_setting').val true

  # If we try to submit any of the individual content forms, stop that action
  # and instead click on the "Submit" button for the entire page.
  $(document).on "submit", "form.autoresponders_form", (event) ->
    return true if event.isActualSubmission

    # If the submission came from inside the "browse images" modal, we don't
    # want to process it here.
    return true if $(event.target).parents("#autoresponder-images-modal").length > 0

    event.preventDefault()
    event.stopPropagation()

    $form = $("form.autoresponders_form")

    ContentEditor.finalizeAllEditors ->

      $storedCriteria = $("#stored-criteria")
      $anonymousCriteria = $("#custom-criteria")

      if $storedCriteria.hasClass("active")
        $anonymousCriteria.find("input[name='autoresponder[use_named_segmentation_criteria]']").attr(disabled: "disabled")
      else
        $storedCriteria.find("input[name='autoresponder[use_named_segmentation_criteria]']").attr(disabled: "disabled")

      event = jQuery.Event("submit")
      event.isActualSubmission = true
      $form.trigger(event)

    # Prevent the form from actually being submitted.
    false
